// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"b69f43e6","436":"d2fd8cf5","453":"f394a27d","501":"6f8a608d","606":"0b487f9b","925":"a1c8a043"}[chunkId] + ".chunk.js";
};